






































































































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling, DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import {
  FETCH_ADDRESS_FELD_LIST,
  FETCH_ADDRESS_GROUP, FETCH_AGENCY_LIST, FETCH_GENERAL_SEARCH_ADDRESS_LIST,
  FETCH_LAND_LIST
} from '@/store/action-types'
import { Land } from '@/model/addresses/Land'
import AddressWindow from '@/components/master-data/address/AddressWindow.vue'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import {
  AdressZusatzfelderType,
  AdressZusatzfelderTypesResponse, AgencyResponse,
  ProjectAddressSearchResponse
} from '@/types/service-response'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import {
  AdressZusatzfelderSearchItem,
  ProjectGeneralAddressSearchRequestPayload
} from '@/types/payload'
import { AddressCountry } from '@/model/addresses/AddressCountry'
import { Agency } from '@/model/addresses/Agency'

import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"

interface ComponentData {
  tableHeight: string,
  loading: boolean

  agencyList: Agency[]
  landList: Land[]
  addressGroupList: AddressGroup[]

  selectedAgencyId: number | null
  sortierung: string
  name: string
  vorname: string
  ort: string
  plz: string
  strasse: string
  region: string
  land: AddressCountry | undefined
  adressgruppe: number | undefined
  telefonprivate: string
  telefongeschaftlich: string
  mailprivat: string
  mailgeschaftlich: string
  maxRecords: number

  addressList: SearchAddress[]
  isDetailButtonDisabled: boolean
  addressStatus: string
  feldList: AdressZusatzfelderType[]
  operatorList: any[]
  boolOperatorNextList: any[]
  additionalFilterList: any[]
}

export default Vue.extend({
  name: 'AddressSearchMultisitePage',

  components: {
    AddressWindow,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxStateStoring
  },

  props: {
    addressGroupId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,

      agencyList: [],
      landList: [],
      addressGroupList: [],

      selectedAgencyId: null,
      sortierung: '',
      name: '',
      vorname: '',
      ort: '',
      plz: '',
      strasse: '',
      region: '',
      land: undefined,
      adressgruppe: undefined,
      telefonprivate: '',
      telefongeschaftlich: '',
      mailprivat: '',
      mailgeschaftlich: '',
      maxRecords: 500,

      addressList: [],
      isDetailButtonDisabled: true,
      addressStatus: '1',
      feldList: [],
      operatorList: [
        {id: 1, name: '='},
        {id: 2, name: 'Like'},
        {id: 3, name: 'grosser'},
        {id: 4, name: 'grosser gleich'},
        {id: 5, name: 'kleiner'},
        {id: 6, name: 'kleiner gleich'},
        {id: 7, name: 'nicht gleich'},
        {id: 8, name: 'nicht wie'}
      ],
      boolOperatorNextList: [
        {id: 0, name: ''},
        {id: 1, name: 'UND'},
        {id: 2, name: 'ODER'}
      ],
      additionalFilterList: [
        {id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}
      ]
    }
  },

  watch: { },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  methods: {
    onChangeFeld (index: number, item: any): void {
      if(item === 0) {
        this.additionalFilterList[index].feld = null
        this.additionalFilterList[index].operator = null
        this.additionalFilterList[index].inhalt = ''
        this.additionalFilterList[index].boolOperatorNext = 0
        this.additionalFilterList.splice(index + 1, this.additionalFilterList.length)
      }
    },

    onChangeAdditional (index: number, item: any): void {
      if(item === 0) {
        if(this.additionalFilterList && this.additionalFilterList[index + 1]) {
          this.additionalFilterList.splice(index + 1, 1)
        }
      } else {
        if(this.additionalFilterList && !this.additionalFilterList[index + 1]) {
          const highId = _.maxBy(this.additionalFilterList, 'id')
          this.additionalFilterList.push({id: highId.id + 1, feld: null, operator: null, inhalt: '', boolOperatorNext: 0})
        }
      }
    },

    onSearchButtonClick (): void {
      this.addressList = []

      let data: any = this.getRouteData()

      data.agencyId = this.selectedAgencyId
      data.sortierung = this.sortierung
      data.name = this.name
      data.vorname = this.vorname
      data.ort = this.ort
      data.plz = this.plz
      data.strasse = this.strasse
      data.region = this.region
      data.land = this.land
      data.adressgruppe = this.adressgruppe
      data.telefonprivate = this.telefonprivate
      data.telefongeschaftlich = this.telefongeschaftlich
      data.mailprivat = this.mailprivat
      data.mailgeschaftlich = this.mailgeschaftlich
      data.addressStatus = this.addressStatus
      data.adressZusatzfelderSearchItems = this.additionalFilterList

      this.$router.push({name: 'AddressSearchMultisite', query: { data: JSON.stringify(data) }})

      this.searchAddress()
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchAddress (): Promise<void> {
      let additionalFilterSearchList: AdressZusatzfelderSearchItem[] = []
      this.additionalFilterList.forEach((item: any) => {
        if(item.feld && item.operator && item.inhalt) {
          additionalFilterSearchList.push({
            Feldtyp: item.feld,
            Operator: item.operator,
            BoolOperatorNext: item.boolOperatorNext,
            Inhalt: item.inhalt
          })
        }
      })
      const payload: ProjectGeneralAddressSearchRequestPayload = {
        Agency: this.selectedAgencyId,
        Sortierung: this.sortierung,
        Adressgruppe: this.adressgruppe ? this.adressgruppe.toString() : '',
        Name: this.name,
        Region: this.region,
        Vorname: this.vorname,
        Land: this.land ? this.land.name : '',
        Ort: this.ort,
        Telefonprivate: this.telefonprivate,
        Telefongeschaftlich: this.telefongeschaftlich,
        AdressZusatzfelderSearchItems: additionalFilterSearchList,
        PLZ: this.plz,
        Mailprivat: this.mailprivat,
        Strasse: this.strasse,
        Mailgeschaftlich: this.mailgeschaftlich,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId,
        MaxRecords: this.maxRecords,
        Aktiv: this.addressStatus === '1',
        Passiv: this.addressStatus === '2',
        Alle: this.addressStatus === '0',
      }

      try {
        this.loading = true
        const response: ProjectAddressSearchResponse = await this.$store.dispatch(FETCH_GENERAL_SEARCH_ADDRESS_LIST, payload)
        if(!response.IsError) {
          this.addressList = SearchAddress.createFromResponse(response.Results)
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    async fetchFeldList (): Promise<void> {
      try {
        const response: AdressZusatzfelderTypesResponse = await this.$store.dispatch(FETCH_ADDRESS_FELD_LIST)
        if(!response.IsError) {
          this.feldList = response.Data
          this.feldList.unshift({
            ID: 0,
            Bezeichnung: ''
          })
        }
      } catch {
      }
    },

    async fetchAgencyList (): Promise<void> {
      try {
        const response: AgencyResponse = await this.$store.dispatch(FETCH_AGENCY_LIST)
        if (response && !response.IsError && response.Data) {
          this.agencyList = Agency.createFromResponse(response.Data)
          if(this.agencyList[0]) {
            this.selectedAgencyId = this.agencyList[0].id
          }
        }
      } catch {

      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/address-search-multisite') {
        this.selectedAgencyId = data.agencyId ? data.agencyId : this.agencyList[0] ? this.agencyList[0].id : null
        this.sortierung = data && data.sortierung ? data.sortierung : ''
        this.name = data && data.name ? data.name : ''
        this.vorname = data && data.vorname ? data.vorname : ''
        this.ort = data && data.ort ? data.ort : ''
        this.plz = data && data.plz ? data.plz : ''
        this.strasse = data && data.strasse ? data.strasse : ''
        this.region = data && data.region ? data.region : ''
        this.land = data && data.land ? data.land : undefined
        this.adressgruppe = data && data.adressgruppe ? data.adressgruppe : undefined
        this.telefonprivate = data && data.telefonprivate ? data.telefonprivate : ''
        this.telefongeschaftlich = data && data.telefongeschaftlich ? data.telefongeschaftlich : ''
        this.mailprivat = data && data.mailprivat ? data.mailprivat : ''
        this.mailgeschaftlich = data && data.mailgeschaftlich ? data.mailgeschaftlich : ''
        this.addressStatus = data && data.addressStatus ? data.addressStatus : '1'
        this.additionalFilterList = data && data.adressZusatzfelderSearchItems ? data.adressZusatzfelderSearchItems : [{id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}]

        if(!_.isEmpty(data)) {
          this.searchAddress()
        }
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  async mounted (): Promise<void> {
    this.setDataFromRoute()
    this.fetchAgencyList()
    this.landList = await this.$store.dispatch(FETCH_LAND_LIST)
    this.addressGroupList = await this.$store.dispatch(FETCH_ADDRESS_GROUP)
    this.fetchFeldList()
  }
})
